import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: false,
})
export class SafePipe implements PipeTransform {
    constructor(protected sanitizer: DomSanitizer) {}

    /**
     Used for preventing the MDR iframe to reload everytime an element from DOM changes replacing
     the sanitizer method from html with the SafePipe.
     */
    public transform(value: string, type: string): SafeUrl | SafeResourceUrl | SafeHtml {
        switch (type) {
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            case 'innerHtml':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
